(() => {
  if (customElements.get('nxo-newsletter-cafe')) return;
  class NexoNewsletterCafe extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.enabled = this.dataset.motionEnabled === 'true';
      this.visible = false;
      this.sky = this.querySelector('.nxo-cafe__sky');
      this.stars = Array.from(this.querySelectorAll('.nxo-cafe__star'), element => ({ element, x: 0, y: 0 }));
      this.flareIn = Math.floor(this.random(2, 6));
      this.meteorIn = 10;
      this.lastFlare = null;
      this.lastMeteor = null;
      document.addEventListener('visibilitychange', () => this.syncMotion(), { signal });
      this.motion.addEventListener('change', () => this.syncMotion(), { signal });
      this.addEventListener('animationend', event => {
        if (event.animationName === 'nxo-cafe-flare') event.target.classList.remove('is-flaring');
        if (event.animationName === 'nxo-cafe-meteor') this.sky?.classList.remove('is-shooting');
      }, { signal });
      this.observer = new IntersectionObserver(([entry]) => {
        this.visible = entry.isIntersecting && entry.intersectionRatio >= .12;
        this.syncMotion();
      }, { threshold: .12 });
      this.observer.observe(this);
      this.syncMotion();
    }
    random(min, max) {
      return min + Math.random() * (max - min);
    }
    syncMotion() {
      const playing = this.enabled && !this.motion.matches && this.visible && !document.hidden;
      this.dataset.playing = String(playing);
      if (playing && !this.starTimer) {
        this.moveStars();
        this.starTimer = setInterval(() => this.tick(), 1000);
      } else if (!playing && this.starTimer) {
        clearInterval(this.starTimer);
        this.starTimer = null;
      }
    }
    tick() {
      this.moveStars();
      if (--this.flareIn <= 0) {
        this.flareStar();
        this.flareIn = Math.floor(this.random(3, 7));
      }
      if (--this.meteorIn <= 0) {
        this.shootMeteor();
        this.meteorIn = 10;
      }
    }
    moveStars() {
      for (const star of this.stars) {
        star.x = Math.max(-36, Math.min(36, star.x + this.random(-10, 10)));
        star.y = Math.max(-18, Math.min(18, star.y + this.random(-5, 5)));
        star.element.style.transform = `translate3d(${star.x.toFixed(2)}px, ${star.y.toFixed(2)}px, 0)`;
      }
    }
    flareStar() {
      const candidates = this.stars.filter(star => star !== this.lastFlare);
      const star = candidates[Math.floor(this.random(0, candidates.length))];
      if (!star) return;
      star.element.style.setProperty('--flare-scale', Math.random() < .5 ? '1.2' : '1');
      star.element.style.setProperty('--flare-duration', `${Math.round(this.random(1500, 2200))}ms`);
      star.element.classList.add('is-flaring');
      this.lastFlare = star;
    }
    shootMeteor() {
      if (!this.sky) return;
      const { width, height } = this.sky.getBoundingClientRect();
      if (!width || !height) return;
      let angle = this.random(12, 28);
      let x = this.random(.08, .3);
      const y = this.random(.08, .32);
      if (Math.random() < .5) { x = 1 - x; angle = 180 - angle; }
      if (this.lastMeteor && Math.abs(x - this.lastMeteor.x) < .15 && Math.abs(y - this.lastMeteor.y) < .1) {
        x = 1 - x;
        angle = 180 - angle;
      }
      const radians = angle * Math.PI / 180;
      const horizontal = (Math.cos(radians) > 0 ? 1 - x : x) * width / Math.abs(Math.cos(radians));
      const vertical = (1 - y) * height / Math.sin(radians);
      const distance = Math.min(horizontal, vertical) * this.random(.55, .82);
      const length = Math.min(100, Math.max(45, width * .09)) * this.random(.8, 1.1);
      for (const [name, value] of Object.entries({
        x: `${(x * width).toFixed(2)}px`, y: `${(y * height).toFixed(2)}px`,
        angle: `${angle.toFixed(2)}deg`, travel: `${distance.toFixed(2)}px`,
        length: `${length.toFixed(2)}px`, duration: `${Math.round(this.random(780, 1100))}ms`
      })) this.sky.style.setProperty(`--meteor-${name}`, value);
      this.sky.classList.add('is-shooting');
      this.lastMeteor = { x, y };
    }
    disconnectedCallback() {
      clearInterval(this.starTimer);
      this.starTimer = null;
      this.observer?.disconnect();
      this.abort?.abort();
      this.stars?.forEach(star => star.element.classList.remove('is-flaring'));
      this.sky?.classList.remove('is-shooting');
      this.dataset.playing = 'false';
      this.abort = null;
    }
  }
  customElements.define('nxo-newsletter-cafe', NexoNewsletterCafe);
})();
